import { FLOW_QUERY_KEYS } from 'utils/constants/flow.constant';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchNodeDetails = ({ flowId, nodeID }) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const isEnabled = nodeID !== '' && (flowId !== '' && flowId !== undefined);

  const {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  } = useQuery(
    [FLOW_QUERY_KEYS.FETCH_NODE_DETAILS, orgId, flowId, nodeID],
    async () => axiosInstance.get(flow(orgId).nodeDetails(flowId, nodeID)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      select: (response) => (response?.data?.nodeDetails ?? {}),
      refetchOnWindowFocus: false,
      enabled: isEnabled,
    },
  );

  return {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  };
};
